window.changeLocale = function(val) {

    //strange behaviour when on pages and switching over to another culture


    let location  = window.location.toString().replace(/\/[a-zA-Z]{2}-[a-zA-Z]{2}/, "/" + val);
    alert(location);

    window.location.replace(location);

    // window.location.href = location;
    //  window.location.reload();

    // $(location).attr('href', 'http://stackoverflow.com')

    // window.open(location,"_blank","",true)

   
    return false;
 };



